import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    BusinessesforSalecardbyId,
    contactInquiry,
} from "../../../Services/APIrequests";
import useStore from "../../../Store";
import Footer from "../Footer/Footer";
import Nav from "../Nav/Nav";
import styles from "./BusinessSalePagebyid.module.css";
import { useNavigate } from "react-router-dom";
import BusinessesforSale1 from "./BusinessesforSale1";
import defaultIMG from "../../../Assets/defaultimg.png";
import parse from "html-react-parser";
import { useForm } from "react-hook-form";
import { MdEmail } from "react-icons/md";
import BusinessCard from "./BusinessCard";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { FaLock, FaShareAlt, FaFacebook, FaTwitter, FaLinkedin, FaWhatsapp, FaLink } from "react-icons/fa";

import {
    checkIfCompanyPaid,
    ContactcreditPricing,
    getMykohere,
    createRazorpayOrderContacts,
    handlePaymentSuccesscontacts,
} from "../../../Services/APIrequests";
const BusinessSalePagebyid = () => {
    const { CIN } = useParams();
    const location = useLocation();
    const [pricingData, setPricingData] = useState([]);

    const [contact, setContact] = useState(0);
    const [showShareOptions, setShowShareOptions] = useState(false);
    const direction = useStore((state) => state.direction);
    const [business, setBusiness] = useState(null);
    const [similarBusinesses, setSimilarBusinesses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [formLoading, setFormLoading] = useState(false);
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        const fetchBusiness = async () => {
            try {
                const response = await BusinessesforSalecardbyId(CIN);
                console.log(response.data);

                // Handle new API response structure
                if (response.data.listing) {
                    setBusiness(response.data.listing);
                    setContact(response?.data?.listing?.isContact || 0);
                    setSimilarBusinesses(response.data.similarIndustries || []);
                } else {
                    // Fallback for old structure
                    setBusiness(response.data);
                }
            } catch (error) {
                console.error("Error fetching business details:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBusiness();
    }, [CIN]);

    if (loading) {
        return (
            <div className={styles.loader}>
                <p>Loading...</p>
            </div>
        );
    }

    if (!business) {
        return (
            <div className={styles.error}>
                <p>Business details not found. Please try again later.</p>
            </div>
        );
    }

    const handleClick = () => {
        navigate(`/kohere/Companydetails/${CIN}`);
    };

    // Form validation functions
    const validateName = (value) =>
        /^[A-Za-z\s]+$/.test(value) ||
        "Full Name can only contain letters and spaces.";

    const validatePhoneNumber = (value) =>
        /^\d+$/.test(value) || "Phone Number can only contain numbers.";

    const validateBusinessName = (value) =>
        !value ||
        /^[A-Za-z\s]+$/.test(value) ||
        "Business Name can only contain letters and spaces.";

    // Form submission handler
    const onSubmit = async (data) => {
        // Check if user is logged in
        const isTokenPresent = sessionStorage.getItem("token");
        if (!isTokenPresent) {
            navigate("/login", { state: { from: location.pathname } });
            return;
        }

        setFormLoading(true);
        const body = {
            name: data.fullName,
            phoneNumber: data.phoneNumber,
            description: data.businessDescription,
            email: data.email,
            location: data.location,
            CIN: CIN,
            ...(data.businessName && { companyName: data.businessName }),
        };

        try {
            const response = await contactInquiry(body);
            if (response.data.success) {
                navigate("/SuccessMsg");
            } else {
                alert(response.data.message || "Something went wrong");
            }
        } catch (error) {
            console.error("Error submitting contact inquiry:", error);
            alert("Something went wrong while submitting the inquiry.");
        } finally {
            setFormLoading(false);
        }
    };

    const ContactCompany = async (CIN) => {
        let body = { companyId: CIN };
        try {
            let res = await checkIfCompanyPaid(body);
            setLoading(false);
            if (res?.data?.Status == 1) {
                navigate(`/ContactBusiness/${CIN}`);
            } else {
                /*   const result = await Swal.fire({
                                title: "Not enough credits",
                                text: "You don't have enough credits. Want to purchase?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonText: "Purchase",
                                cancelButtonText: "Cancel",
                                reverseButtons: true,
                            });
    
                            if (result.isConfirmed) {
                                navigate("/kohere/mycredits", {
                                    state: {
                                        from: `/ContactBusiness/${CIN}`,
                                        active: "ContactCredits",
                                    },
                                });
                            } */
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    const handleSubscribe = async (
        razorpay_order_Id,
        razorpay_payment_id,
        credits
    ) => {
        try {
            const data2 = {
                razorpay_order_id: razorpay_order_Id,
                razorpay_payment_id: razorpay_payment_id,
                credits: credits,
            };

            const paymentCartDetailsApi1 = await handlePaymentSuccesscontacts(
                data2
            );

            if (paymentCartDetailsApi1.status === 200) {
                ContactCompany(CIN);
            } else {
                alert(
                    paymentCartDetailsApi1.message ||
                    "Something went wrong while processing the subscription."
                );
            }
        } catch (error) {
            console.error("Error in handleSubscribe:", error);
            alert("An unexpected error occurred. Please try again.");
        }
    };
    const handleContactClick = async (e, CIN) => {
        e.stopPropagation();
        const isTokenPresent = sessionStorage.getItem("token");
        let pricingItem = pricingData?.filter((item) => item.minCredits == 1);
        if (pricingItem.length > 0) {
            pricingItem = pricingItem[0];
        }
        if (isTokenPresent) {
            if (contact == 1) {
                navigate(`/ContactBusiness/${CIN}`);
            } else {
                let contactCredits = 0;
                try {
                    const resp = await getMykohere(isTokenPresent);
                    contactCredits = resp?.data?.user?.contactCredits || 0;
                } catch (err) {
                    console.error("Failed to fetch user credits", err);
                }
                console.log(pricingData);
                const creditDisabled = contactCredits <= 0 ? "disabled" : "";
                Swal.fire({
                    title: `Contact ${business.business_name}`,
                    html: `
                                              <div style="font-family:inherit; text-align:left;">
                                                  <div style="margin-bottom:10px; font-weight:600; color:#333;">Select Payment Method</div>
              
                                                  <div style="display:flex; gap:12px; margin-bottom:14px;">
                                                      <label class="swal-unlock-label" data-value="pay" style="flex:1; border-radius:10px; padding:14px; display:flex; align-items:center; gap:12px; cursor:pointer; background:#fff; position:relative;">
                                                          <input id="swal-unlock-pay" type="radio" name="unlockOption" value="pay" style="display:none;" />
                                                          <div class="swal-unlock-check" style="width:36px;height:36px;border-radius:50%;background:var(--PrimaryColor);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:18px;">✓</div>
                                                          <div>
                                                              <div  style="font-size:16px;color:var(--PrimaryColor);font-weight:600;">Pay ₹${pricingItem?.pricePerCredit
                        }</div>
                                                              <div style="font-size:12px;color:var(--PrimaryColor);">One-time payment</div>
                                                          </div>
                                                       
                                                      </label>
    
                                                      <label class="swal-unlock-label" data-value="credit" style="flex:1; border:2px dashed #dcdcdc; border-radius:10px; padding:14px; display:flex; align-items:center; gap:12px; cursor:pointer; background:#fafafa; position:relative;">
                                                      
                                                          <div class="swal-unlock-check" style="width:36px;height:36px;border-radius:50%;background:var(--PrimaryColor);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:18px;">✓</div>
                                                          <input id="swal-unlock-credit" type="radio" name="unlockOption" value="credit" ${creditDisabled} style="display:none;" />
                                                       
                                                          <div>
                                                              <div style="font-size:16px;color:#444;font-weight:600;">Pay using Credit</div>
                                                              <div style="font-size:12px;color:${contactCredits <=
                            0
                            ? "#d9534f"
                            : "#999"
                        };">${contactCredits <= 0
                            ? "No Credits Available"
                            : "Use 1 credit"
                        }</div>
                                                          </div>
                                                        
                                                      </label>
                                                  </div>
              
                                                  <div style="margin:14px 0;">
                                                      <button id="swal-buy-credits" style="background:var(--PrimaryColor);color:#fff;padding:12px 18px;border-radius:8px;border:none;box-shadow:0 6px 18px rgba(0,0,0,0.08);cursor:pointer;width:100%;">Unlock Attractive Prices & Single Click Purchasing Credits!</button>
                                                  </div>
              
                                                  <div style="margin-top:12px; font-size:13px; color:#333; text-align:left;">
                                                      <strong>Additional Information</strong>
                                                      <ul style="margin:8px 0 0 18px; color:#444;">
                                                          <li>View corporate profile for you view the year from a year from rom unlock date.</li>
                                                          <li>Prices shown exclusive of GST.</li>
                                                      </ul>
                                                  </div>
                                              </div>
                                      `,
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText: "Proceed to Checkout",
                    cancelButtonText: "Cancel",
                    showLoaderOnConfirm: true,
                    didOpen: () => {
                        const buyBtn =
                            document.getElementById("swal-buy-credits");
                        if (buyBtn) {
                            buyBtn.addEventListener("click", () => {
                                // navigate to buy credits page
                                navigate("/kohere/mycredits", {
                                    state: {
                                        from: `/BusinessesforSale`,
                                        active: "ContactCredits",
                                    },
                                });
                                Swal.close();
                            });
                        }

                        // Wire up selectable labels so only one is highlighted at a time
                        const labels =
                            document.querySelectorAll(".swal-unlock-label");

                        function updateSelection(value) {
                            labels.forEach((lbl) => {
                                const input = lbl.querySelector(
                                    'input[name="unlockOption"]'
                                );
                                const check =
                                    lbl.querySelector(".swal-unlock-check");
                                if (!input) return;
                                if (lbl.dataset.value === value) {
                                    input.checked = true;
                                    lbl.style.boxShadow =
                                        "0 4px 14px rgba(0,0,0,0.08)";
                                    lbl.style.border =
                                        "2px solid var(--PrimaryColor)";
                                    if (check) check.style.display = "flex";
                                } else {
                                    input.checked = false;
                                    lbl.style.boxShadow = "none";
                                    if (lbl.dataset.value === "credit") {
                                        lbl.style.border = "2px dashed #dcdcdc";
                                    } else {
                                        lbl.style.border = "2px solid #dcdcdc";
                                    }
                                    if (check) check.style.display = "none";
                                }
                            });
                        }

                        labels.forEach((lbl) => {
                            lbl.addEventListener("click", (ev) => {
                                const input = lbl.querySelector(
                                    'input[name="unlockOption"]'
                                );
                                if (!input) return;
                                // Respect disabled attribute on input
                                if (input.disabled) return;
                                updateSelection(lbl.dataset.value);
                            });
                        });

                        // Set default selection: pay
                        updateSelection("pay");
                    },
                    preConfirm: async () => {
                        try {
                            const selected = document.querySelector(
                                'input[name="unlockOption"]:checked'
                            );
                            const val = selected ? selected.value : "pay";
                            if (val === "credit") {
                                // user chose to use credit — call unlock handler and wait
                                await ContactCompany(CIN);
                                return { used: "credit" };
                            } else {
                                // user chose to pay — create order and open Razorpay, wait for create order
                                let TotalPrice =
                                    Number(pricingItem?.pricePerCredit) +
                                    Number(pricingItem?.pricePerCredit * 0.18);

                                console.log(TotalPrice);
                                const roundedAmount = parseFloat(
                                    TotalPrice || 0
                                );

                                const paymentCartDetailsApi =
                                    await createRazorpayOrderContacts({
                                        amount: roundedAmount,
                                    });

                                if (paymentCartDetailsApi.status === 201) {
                                    const options = {
                                        key: process.env.REACT_APP_RAZORPAYKEY_TEST,
                                        amount: roundedAmount * 100,
                                        currency: "INR",
                                        name: "Kohere",
                                        description: "Order Payments",
                                        order_id:
                                            paymentCartDetailsApi.data
                                                .razorpay_orderId,
                                        handler: function (response) {
                                            if (
                                                response.razorpay_payment_id !==
                                                null
                                            ) {
                                                handleSubscribe(
                                                    paymentCartDetailsApi.data
                                                        .data.razorpay_orderId,
                                                    response.razorpay_payment_id,
                                                    1,
                                                    CIN
                                                );
                                            } else {
                                                alert(
                                                    "Something went wrong, please try again."
                                                );
                                            }
                                        },
                                        prefill: {
                                            name: "kohere",
                                            email: "kohere@gmail.com",
                                        },
                                        notes: { address: "" },
                                        theme: { color: "#FDFBB9" },
                                    };

                                    const rzp1 = new window.Razorpay(options);
                                    rzp1.open();
                                    return { used: "pay" };
                                } else {
                                    throw new Error("Failed to create order");
                                }
                            }
                        } catch (err) {
                            Swal.showValidationMessage(
                                `Request failed: ${err.message}`
                            );
                            throw err;
                        }
                    },
                });
            }
        } else {
            navigate("/login", { state: { from: location.pathname } });
        }
    };
    return (
        <div style={{ direction }}>
            <Nav />

            <div className={styles.about_container}>
                <BusinessesforSale1 />
            </div>

            <div className={styles.Pagebyidbusiness_one}>
                <div>
                    <h3>{business.business_name}
                        <span className={styles.shareContainerDetail} style={{ marginLeft: '12px', position: 'relative', display: 'inline-block', verticalAlign: 'middle' }}>
                            <button
                                className={styles.shareButtonDetail}
                                onClick={() => setShowShareOptions(!showShareOptions)}>
                                <FaShareAlt />
                            </button>
                            {showShareOptions && (
                                <div className={styles.shareDropdownDetail}>
                                    <a href={`https://facebook.com/sharer/sharer.php?u=${window.location.origin}/BusinessesforSale/${CIN}`} target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
                                    <a href={`https://twitter.com/intent/tweet?url=${window.location.origin}/BusinessesforSale/${CIN}`} target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
                                    <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${window.location.origin}/BusinessesforSale/${CIN}`} target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
                                    <a href={`https://wa.me/?text=${window.location.origin}/BusinessesforSale/${CIN}`} target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
                                    <a onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/BusinessesforSale/${CIN}`); Swal.fire({ icon: 'success', title: 'Copied!', text: 'Link copied to clipboard', timer: 1500, showConfirmButton: false }); setShowShareOptions(false); }} style={{ cursor: 'pointer' }}><FaLink /></a>
                                </div>
                            )}
                        </span>
                    </h3>

                    {/* Description and Business Image Section */}
                    {(business.business_image ||
                        business.about_company ||
                        business.document) && (
                            <div className={styles.descriptionImageContainer}>
                                {(business.about_company || business.document) && (
                                    <div className={styles.descriptionSection}>
                                        {business.about_company && (
                                            <div className={styles.aboutCompany}>
                                                {parse(
                                                    business.about_company || ""
                                                )}
                                            </div>
                                        )}

                                        {/* Business Document Button */}
                                        {business.document && (
                                            <a
                                                href={business.document}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={
                                                    styles.business_documentLink
                                                }>
                                                Click here to view the Business
                                                Document
                                            </a>
                                        )}
                                    </div>
                                )}
                                {/* Business Image on the right side */}
                                {business.business_image && (
                                    <div className={styles.businessImageSidebar}>
                                        <img
                                            src={business.business_image}
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = defaultIMG;
                                            }}
                                            alt={business.business_name}
                                            className={styles.sidebarImage}
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                    <div className={styles.Pagebyidheader}>
                        <div className={styles.Pagebyidheadercontent}>
                            <h3 className={styles.page_heading_details}>
                                Business Details
                            </h3>
                            <table className={styles.PagebyiddetailsTable}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <strong>Vintage Years:</strong>
                                        </td>
                                        <td>
                                            {business.vintage_year ||
                                                "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>Legal Entity:</strong>
                                        </td>
                                        <td>
                                            {business.legal_entity ||
                                                "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>Industry:</strong>
                                        </td>
                                        <td>
                                            {Array.isArray(business.industry)
                                                ? business.industry.join(", ")
                                                : business.industry ||
                                                "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>Email:</strong>
                                        </td>
                                        <td>
                                            {business.email || "Not Available"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <strong>Location:</strong>
                                        </td>
                                        <td>
                                            {business.location ||
                                                "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>PAT:</strong>
                                        </td>
                                        <td>
                                            {business?.pat || "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>ROC:</strong>
                                        </td>
                                        <td>
                                            {business.roc || "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>Listed By:</strong>
                                        </td>
                                        <td>
                                            {business.listed_by ||
                                                "Business Owner / Director"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>Status:</strong>
                                        </td>
                                        <td>
                                            {business.status || "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>Sale Price:</strong>
                                        </td>
                                        <td>
                                            {business.sale_price ||
                                                "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>Turn Over:</strong>
                                        </td>
                                        <td>
                                            {business.turn_over ||
                                                "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>
                                                Date of Incorporation:
                                            </strong>
                                        </td>

                                        <td>
                                            {business.date_of_incorporation
                                                ? new Date(
                                                    business.date_of_incorporation
                                                ).toLocaleDateString(
                                                    "en-GB",
                                                    {
                                                        year: "numeric",
                                                        month: "short",
                                                        day: "2-digit",
                                                    }
                                                )
                                                : "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>Authorized Capital:</strong>
                                        </td>

                                        <td>
                                            {business.authorised_capital ||
                                                "Not Available"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <strong>Paid Up Capital:</strong>
                                        </td>
                                        <td>
                                            {business.paid_up_capital ||
                                                "Not Available"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>Website:</strong>
                                        </td>
                                        <td>
                                            {business?.google
                                                ? business?.google
                                                : "NA"}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className={styles.Pagebyid_knowmore}>
                                <button
                                    className={styles.Pagebyid_knowmore_button}
                                    onClick={handleClick}>
                                    Know More
                                </button>
                            </div>
                        </div>

                        {/* Contact Form Section */}
                        <div style={{ position: "relative" }}>
                            <div
                                className={`${styles.contactFormContainer} ${contact === 0 ? styles.blurredForm : ""
                                    }`}>
                                <div className={styles.formWrapper}>
                                    <div className={styles.header}>
                                        <h2>
                                            <MdEmail className={styles.icon} />{" "}
                                            Contact Business
                                        </h2>
                                    </div>
                                    <p className={styles.subText}>
                                        One Time Registration
                                    </p>

                                    <form
                                        onSubmit={handleSubmit(onSubmit)}
                                        className={styles.form}>
                                        {/* Full Name */}
                                        <div className={styles.formGroup}>
                                            <label>Full Name</label>
                                            <input
                                                type="text"
                                                placeholder="Enter your full name"
                                                {...register("fullName", {
                                                    required:
                                                        "Full Name is required",
                                                    validate: validateName,
                                                })}
                                            />
                                            {errors.fullName && (
                                                <span className={styles.error}>
                                                    {errors.fullName.message}
                                                </span>
                                            )}
                                        </div>

                                        {/* Phone Number */}
                                        <div className={styles.formGroup}>
                                            <label>Phone Number</label>
                                            <input
                                                type="tel"
                                                placeholder="Enter your phone number"
                                                {...register("phoneNumber", {
                                                    required:
                                                        "Phone Number is required",
                                                    validate:
                                                        validatePhoneNumber,
                                                })}
                                            />
                                            {errors.phoneNumber && (
                                                <span className={styles.error}>
                                                    {errors.phoneNumber.message}
                                                </span>
                                            )}
                                        </div>

                                        {/* Business Name */}
                                        <div className={styles.formGroup}>
                                            <label>
                                                Business Name (optional)
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Enter your business name"
                                                {...register("businessName", {
                                                    validate:
                                                        validateBusinessName,
                                                })}
                                            />
                                            {errors.businessName && (
                                                <span className={styles.error}>
                                                    {
                                                        errors.businessName
                                                            .message
                                                    }
                                                </span>
                                            )}
                                        </div>

                                        {/* Description */}
                                        <div className={styles.formGroupFull}>
                                            <label>Description</label>
                                            <textarea
                                                placeholder="Provide a brief description"
                                                {...register(
                                                    "businessDescription",
                                                    {
                                                        required:
                                                            "Description is required",
                                                    }
                                                )}
                                                rows="4"
                                            />
                                            {errors.businessDescription && (
                                                <span className={styles.error}>
                                                    {
                                                        errors
                                                            .businessDescription
                                                            .message
                                                    }
                                                </span>
                                            )}
                                        </div>

                                        {/* Email */}
                                        <div className={styles.formGroup}>
                                            <label>Email</label>
                                            <input
                                                type="email"
                                                placeholder="Enter your email address"
                                                {...register("email", {
                                                    required:
                                                        "Email is required",
                                                })}
                                            />
                                            {errors.email && (
                                                <span className={styles.error}>
                                                    {errors.email.message}
                                                </span>
                                            )}
                                        </div>

                                        {/* Location */}
                                        <div className={styles.formGroup}>
                                            <label>Location</label>
                                            <input
                                                type="text"
                                                placeholder="Enter your location"
                                                {...register("location", {
                                                    required:
                                                        "Location is required",
                                                })}
                                            />
                                            {errors.location && (
                                                <span className={styles.error}>
                                                    {errors.location.message}
                                                </span>
                                            )}
                                        </div>

                                        {/* Submit */}
                                        <button
                                            type="submit"
                                            className={styles.submitBtn}
                                            disabled={
                                                formLoading || contact === 0
                                            }>
                                            {formLoading
                                                ? "Submitting..."
                                                : contact === 0
                                                    ? "Contact Required"
                                                    : "Continue"}
                                        </button>
                                    </form>
                                </div>
                            </div>

                            {contact === 0 && (
                                <div
                                    className={styles.lockOverlayCustom}
                                    onClick={(e) => handleContactClick(e, CIN)}>
                                    <FaLock className="lockIconCustom" />
                                    <div className="lockLabel">
                                        Click to unlock and contact{" "}
                                        {business.business_name}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {similarBusinesses.length > 0 && (
                        <div className={styles.similarCompaniesSection}>
                            <h2 className={styles.similarCompaniesTitle}>
                                Similar Companies
                            </h2>
                            <div className={styles.similarCompaniesGrid}>
                                {similarBusinesses.map((card, index) => (
                                    <BusinessCard
                                        key={index}
                                        CIN={card.CIN}
                                        title={card.business_name}
                                        location={card.location}
                                        about_company={card.about_company}
                                        pat={card.pat}
                                        turn_over={card.turn_over}
                                        paid_up_capital={card.paid_up_capital}
                                        authorised_capital={
                                            card.authorised_capital
                                        }
                                        sale_price={card.sale_price}
                                        business_image={card.business_image}
                                        date_of_incorporation={
                                            card.date_of_incorporation
                                        }
                                        legal_entity={card.legal_entity}
                                        industry={
                                            Array.isArray(card.industry)
                                                ? card.industry[0]
                                                : card.industry
                                        }
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                {business.businessImages &&
                    business.businessImages.length > 0 && (
                        <div className={styles.images}>
                            {business.businessImages.map((imgUrl, idx) => (
                                <img key={idx} src={imgUrl.image} />
                            ))}
                        </div>
                    )}
            </div>

            <Footer />
        </div>
    );
};

export default BusinessSalePagebyid;
